import { render, staticRenderFns } from "./WaitingStatus.vue?vue&type=template&id=71608a7b&"
import script from "./WaitingStatus.vue?vue&type=script&lang=js&"
export * from "./WaitingStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports